module.exports = __webpack_public_path__ + "img/sv57.fb1dea5c.svg";